import { fill } from 'lodash';
import Skeleton from 'react-loading-skeleton';

const ListItem: React.FC = () => (
	<div className="list-group-item px-0 py-3">
		<Skeleton height={24} style={{ lineHeight: 1.5 }} />
	</div>
);

export const ProductSkeleton: React.FC = () => {
	return (
		<div className="product-product-skeleton">
			<div className="product-header px-3">
				<div
					className="d-flex justify-content-center"
					style={{ paddingTop: 10 }}
				>
					<Skeleton circle={true} height={236} width={236} />
				</div>

				<div className="pt-4">
					<h1 className="">
						<Skeleton
							width={300}
							// height={33.6}
							style={{ lineHeight: 1.2 }}
						/>
					</h1>

					<h6 className="mb-0">
						<Skeleton
							width={200}
							// height={23.19}
							style={{ lineHeight: 1.2 }}
						/>
					</h6>

					<small className="d-block mt-0 mb-3">
						<Skeleton
							width={400}
							// height={19.2}
							style={{ lineHeight: 1 }}
						/>
					</small>

					<h4 className="mb-2">
						<Skeleton
							width={250}
							// height={24}
							style={{ lineHeight: 1.2 }}
						/>
					</h4>
				</div>
			</div>

			<div className="product-body px-3 mb-3">
				<div className="modifiers list-group list-group-flush">
					{/* {fill(Array(11), <ListItem />)} */}
					{fill(Array(11), null).map((_, key) => (
						<ListItem key={key} />
					))}
				</div>
			</div>
		</div>
	);
};
